import {
  createCardanoRewardSourceId,
  createCardanoTxSourceId,
} from '@pkg/cardano'
import { cardanoTxHashSchema } from '@pkg/cardano'
import { z } from 'zod'

/** 永続化前の Cardano イベントを種類ごとに検証する。 */
export const cardanoEventSchema = z.discriminatedUnion('kind', [
  z.object({
    kind: z.literal('tx'),
    txHash: cardanoTxHashSchema,
    timestamp: z.number().int().nonnegative().safe(),
  }),
  z.object({
    kind: z.literal('reward'),
    payoutEpoch: z.number().int().nonnegative().safe(),
    timestamp: z.number().int().nonnegative().safe(),
    rewardAmount: z.string().regex(/^(0|[1-9][0-9]*)$/),
  }),
])

/** ページ単位で保存する Cardano の Tx または配分報酬。 */
export type CardanoEvent = z.infer<typeof cardanoEventSchema>

/**
 * account 単位のイベントから安定した Source ID を求める。
 * @param params イベントと登録済み Stake 同期キー
 * @returns Tx と報酬の間で衝突しない Source ID
 */
export const getCardanoEventSourceId = (params: {
  event: CardanoEvent
  stakeAddress: string | null
}): string =>
  params.event.kind === 'tx'
    ? createCardanoTxSourceId({ txHash: params.event.txHash })
    : createCardanoRewardSourceId({
        stakeAddress: z.string().parse(params.stakeAddress),
        payoutEpoch: params.event.payoutEpoch,
      })
